import { IBaseSingleResultDto } from '@skillarea/lib-shared';

export const CHEST_OPENING_DURATION_MS = 950;
export const CHEST_JUST_OPENED_DURATION_MS = 1000;

export const normalizeSingle = <T>(
  response?: IBaseSingleResultDto<T> | T,
): T | undefined => {
  if (!response) return undefined;
  if (typeof response === 'object' && response && 'data' in response) {
    return (response as IBaseSingleResultDto<T>).data;
  }
  return response as T;
};
